module.exports = __webpack_public_path__ + "img/2.af095df2.jpg";